import type { ReactNode } from "react";

import type { IconName } from "@luce/ui";
import { Box, Icon, Typography } from "@luce/ui";

interface InvoiceSectionProps {
  icon: IconName;
  title: string;
  children: ReactNode;
}

export function InvoiceSection({ icon, title, children }: InvoiceSectionProps) {
  return (
    <Box className="gap-spacing-md flex flex-col">
      <Box className="gap-spacing-md flex flex-row items-center">
        <Icon name={icon} size={24} weight="fill" className="text-luce-brand-primary" />
        <Typography variant="label-md" color="neutral-foreground-default">
          {title}
        </Typography>
      </Box>
      {children}
    </Box>
  );
}
